/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

const ROLES = {
    SYSTEM_ADMIN: "SYSTEM_ADMIN",
    TENANT_ADMIN: "TENANT_ADMIN",
    GENERAL_USER: "GENERAL_USER"
}

export const ROLES_DESCRIPTION = {
    [ROLES.SYSTEM_ADMIN]: 'システム管理者',
    [ROLES.TENANT_ADMIN]: '組織管理者',
    [ROLES.GENERAL_USER]: '一般利用者'
}

export default ROLES